import { render } from "./businessData.vue?vue&type=template&id=0cc59cd0&scoped=true"
import script from "./businessData.vue?vue&type=script&lang=js"
export * from "./businessData.vue?vue&type=script&lang=js"

import "./businessData.vue?vue&type=style&index=0&id=0cc59cd0&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc59cd0"]])

export default __exports__